import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { actions as fusionActions } from '../../reducers/fusion';
import './RenderLegacyCusto.scss';

import ChannelCategory from './ChannelCategory';

const RenderLegacyCusto = ({ currentSubproducts }) => {
  const [content, setContent] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (currentSubproducts.length) {
      setContent(
        currentSubproducts.reduce((acc, curr) => {
          if (
            !acc.map((category) => category.label).includes(curr.categoria1)
          ) {
            acc.push({ label: curr.categoria1, channels: [curr] });
            return acc;
          }
          const index = acc.findIndex(
            (category) => category.label === curr.categoria1
          );
          acc[index] = {
            ...acc[index],
            channels: [...acc[index].channels, curr],
          };
          return acc;
        }, [])
      );
    }
  }, [currentSubproducts]);

  useEffect(() => {
    if (content.length) {
      dispatch(fusionActions.setHasRenderedChannels(true));
    }

    return () => {
      dispatch(fusionActions.setHasRenderedChannels(false));
    }
  }, [content, dispatch]);

  return (
    <div id="idListaCanales">
      {content.map((category) => (
        <ChannelCategory category={category} />
      ))}
    </div>
  );
};

export default RenderLegacyCusto;
